<template>
  <Layout>
    <div class="container" style="margin-top:2rem" >
      <table class="table table-bordered text-center" style="text-align:center" >
        <thead>
            <tr>
                <th style="text-align:center" >#</th>
                <th style="text-align:center" >Name</th>
                <th style="text-align:center" >Jurisdictions</th>
            </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Financial Brokerage Group</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Egyptian Fund Management Group</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Egyptian Portfolio Management Group</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Hermes Securities Brokerage</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Hermes Fund Management</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>6</td>
            <td>EFG-Hermes Advisory Inc.</td>
            <td>BVI</td>
          </tr>
          <tr>
            <td>7</td>
            <td>EFG-Hermes Financial Management (Egypt) Limited.</td>
            <td>Bermuda</td>
          </tr>
          <tr>
            <td>8</td>
            <td>Bayonne Enterprises Ltd.</td>
            <td>BVI</td>
          </tr>
          <tr>
            <td>9</td>
            <td>EFG-Hermes Management</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>10</td>
            <td>EFG-Hermes Private Equity Ltd</td>
            <td>BVI</td>
          </tr>
          <tr>
            <td>11</td>
            <td>EFG-Hermes Brokerage U.A.E. LLC</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>12</td>
            <td>EFG-Hermes UAE Limited</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>13</td>
            <td>EFG-Hermes Fixed Income</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>14</td>
            <td>EFG-Hermes Promoting &amp; Underwriting</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>15</td>
            <td>Hermes Corporate Finance</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>16</td>
            <td>Flemming CIIC Holdings</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>17</td>
            <td>Flemming Mansour Securities</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>18</td>
            <td>Flemming CIIC Securities</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>19</td>
            <td>Flemming CIIC Corporate Finance</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>20</td>
            <td>MENA Opportunities Management Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>21</td>
            <td>MENA (BVI) Holdings Limited</td>
            <td>BVI</td>
          </tr>
          <tr>
            <td>22</td>
            <td>Middle East North Africa Financial Investments W.L.L.</td>
            <td>Bahrain</td>
          </tr>
          <tr>
            <td>23</td>
            <td>EFG-Hermes KSA</td>
            <td>Saudi Arabia</td>
          </tr>
          <tr>
            <td>24</td>
            <td>EFG-Hermes Frontier Holdings LLC</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>25</td>
            <td>EFG-Hermes Holding Lebanon</td>
            <td>Lebanon</td>
          </tr>
          <tr>
            <td>26</td>
            <td>EFG-Hermes Lebanon</td>
            <td>Lebanon</td>
          </tr>
          <tr>
            <td>27</td>
            <td>Tanmeyah Micro Enterprise Services S.A.E</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>28</td>
            <td>EFG-Hermes MENA Securities Limited</td>
            <td>British Virgin Islands</td>
          </tr>
          <tr>
            <td>29</td>
            <td>EFG-Hermes Regional Investments Ltd.</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>30</td>
            <td>EFG-Hermes Oman LLC.</td>
            <td>Oman</td>
          </tr>
          <tr>
            <td>31</td>
            <td>EFG-Hermes IFA Financial Brokerage Company</td>
            <td>Kuwait.</td>
          </tr>
          <tr>
            <td>32</td>
            <td>Offset Holding KSC</td>
            <td>Kuwait.</td>
          </tr>
          <tr>
            <td>33</td>
            <td>IDEAVELOPERS</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>34</td>
            <td>EFG Hermes CB Holding Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>35</td>
            <td>EFG Hermes Global CB Holding Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>36</td>
            <td>EFG Hermes Syria LLC (under liquidation)</td>
            <td>Syria</td>
          </tr>
          <tr>
            <td>37</td>
            <td>Sindyan Syria LLC (under liquidation)</td>
            <td>Syria</td>
          </tr>
          <tr>
            <td>38</td>
            <td>Talas &amp; Co. LLP (under liquidation)</td>
            <td>Syria</td>
          </tr>
          <tr>
            <td>39</td>
            <td>EFG Hermes Jordan</td>
            <td>Jordan</td>
          </tr>
          <tr>
            <td>40</td>
            <td>MENA Long Term Value Feeder Holdings Ltd.</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>41</td>
            <td>MENA Long-Term Value Master Holdings Ltd.</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>42</td>
            <td>MENA Long-Term Value Management Ltd.</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>43</td>
            <td>EFG Hermes CL Holding SAL</td>
            <td>Lebanon.</td>
          </tr>
          <tr>
            <td>44</td>
            <td>EFG-Hermes Leasing</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>45</td>
            <td>EFG-Hermes Direct Investment Fund</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>46</td>
            <td>EFG Hermes Investment Fund Co.</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>47</td>
            <td>EFG-Hermes IB Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>48</td>
            <td>Financial Group for Securitization</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>49</td>
            <td>Beaufort Investments S.à.r.l.</td>
            <td>Luxembourg</td>
          </tr>
          <tr>
            <td>50</td>
            <td>EFG - Hermes USA</td>
            <td>USA</td>
          </tr>
          <tr>
            <td>51</td>
            <td>EFG Capital Partners III</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>52</td>
            <td>Health Mangement Company</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>53</td>
            <td>EFG Hermes Kenya LTD</td>
            <td>Kenya</td>
          </tr>
          <tr>
            <td>54</td>
            <td>EFG Finance Holding</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>55</td>
            <td>EFG Hermes Pakistan Limited</td>
            <td>Pakistan</td>
          </tr>
          <tr>
            <td>56</td>
            <td>EFG Hermes UK Limited</td>
            <td>UK</td>
          </tr>
          <tr>
            <td>57</td>
            <td>OLT Investment International Company (B.S.C)</td>
            <td>Bahrain</td>
          </tr>
          <tr>
            <td>58</td>
            <td>Frontier Investment Management Partners LTD</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>59</td>
            <td>EFG Hermes SP Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>60</td>
            <td>Valu</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>61</td>
            <td>EFG Hermes Factoring</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>62</td>
            <td>Beaufort Asset Managers LTD</td>
            <td>UK</td>
          </tr>
          <tr>
            <td>63</td>
            <td>EFG-Hermes PE Holding LLC</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>64</td>
            <td>EFG-Hermes Bangladesh</td>
            <td>Bangladesh</td>
          </tr>
          <tr>
            <td>65</td>
            <td>EFG Hermes FI Limited</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>66</td>
            <td>EFG Hermes Securitization</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>67</td>
            <td>Etkan for Inquiry and Collection and Business Processes</td>
            <td>Egypt</td>
          </tr>
          <tr>
            <td>68</td>
            <td>RX HealthCare Management</td>
            <td>Mauritius</td>
          </tr>
          <tr>
            <td>69</td>
            <td>FIM Partners KSA Capital</td>
            <td>Saudi Arabia</td>
          </tr>
          <tr>
            <td>70</td>
            <td>Egypt Education Fund GP Limited</td>
            <td>UAE</td>
          </tr>
          <tr>
            <td>71</td>
            <td>EFG Hermes Nigeria Limited</td>
            <td>Nigeria</td>
          </tr>
          <tr>
            <td>72</td>
            <td>EFG-Hermes Int. Fin Corp</td>
            <td>Cayman Islands</td>
          </tr>
          <tr>
            <td>73</td>
            <td>FIM Partners UK Ltd</td>
            <td>UK</td>
          </tr>
          <tr>
            <td>74</td>
            <td>EFG Hermes Sukuk</td>
            <td>Egypt</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/components/layouts/Layout.vue";
export default {
  name: "Affilliates",
  components: { Layout },
};
</script>